<template>
  <div class="view home">
    <b-container>
      <b-button id="btnId" v-b-modal="'alertModal'" style="display:none;"
        >Show Modal</b-button
      >
      <!-- <b-modal id="my-modal">Hello From My Modal!</b-modal> -->
    </b-container>
    <b-container class="landingpage-container">
      <section class="landingpage">
        <b-row>
          <b-col md="12" class="text-center">
            <div class="textwrapper">
              <b-img
                src="/img/desktop-landingtext.svg"
                class="d-none d-md-block desktoptext"
                v-in-viewport
                alt="Community Built From The Ground Up"
              />

              <b-img
                src="/img/icons/community-title.svg"
                v-in-viewport
                alt="Community"
                fluid
                center
                class="community-title d-block d-md-none"
              />
              <p
                class="text--extrabold mb-10 flexFont d-block d-md-none"
                v-in-viewport
              >
                Built From <br class="d-block d-sm-none" />The Ground Up
              </p>

              <p class="w-40 mx-auto text--bold mb-0" v-in-viewport>
                At New Seaton, we have that new home feeling throughout
                <br class="d-none d-md-block" />our whole community. Every
                detail of this community has been planned
                <br class="d-none d-sm-block" />to make your life easier.
              </p>
            </div>
          </b-col>
        </b-row>
      </section>
    </b-container>

    <!-- Removed on June 29, 2020 / THIS MIGHT COME BACK -->
    <section id="icons-sections">
      <div class="bubble-section" style="background-color: #abdbee;">
        <b-container fluid>
          <b-row>
            <b-col>
              <bubble-svg class="d-none d-md-block bubble-svg" />
            </b-col>
          </b-row>
        </b-container>
        <bubble-mobile class="d-block d-md-none bubble-mobile mb-5" />
      </div>
    </section>

    <!-- New Section Add -->
    <section id="builder-selection">
      <b-container class="home-selector">
        <b-row>
          <b-col>
            <h2 class="home-selector-title">
              Choose Your Style. Choose Your Home
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <nuxt-link to="/aspenridgeHomes" class="event-none">
            <!-- <nuxt-link :to="`/aspenridgeHomes${localStorage.sourceQuery}`" class="event-none"> -->
            
              <b-img fluid src="/img/aspenridge-index.jpg" alt="aspenridge index"/>
              <div class="logo-container">
                <b-img fluid src="/img/icons/button-logo-aspenridge.png"  alt="aspenridge logo"/>
              </div>
            </nuxt-link>
          </b-col>
          <b-col md="4">
            <nuxt-link to="/brookfieldHomes" class="event-none">
            <!-- <nuxt-link :to="`/brookfieldHomes${localStorage.sourceQuery}`" class="event-none"> -->
              <b-img fluid src="/img/brookfield-index.png" alt="brookfield index"/>
              <div class="logo-container">
                <b-img fluid src="/img/icons/button-logo-brookfield.png" alt="brookfield logo"/>
              </div>
            </nuxt-link>
          </b-col>
          <b-col md="4">
            <nuxt-link to="/towerhillHomes" class="event-none">
            <!-- <nuxt-link :to="`/towerhillHomes${localStorage.sourceQuery}`" class="event-none"> -->
              <b-img fluid src="/img/towerhill-index.jpg" alt="towerhill index"/>
              <div class="logo-container">
                <b-img fluid src="/img/icons/button-logo-towerhill.png" alt="towerhill logo"/>
              </div>
            </nuxt-link>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!-- New Section End -->

    <section class="background--white" id="graph-section">
      <b-container>
        <section>
          <b-row>
            <b-col md="12">
              <br />
              <div class="d-none d-sm-block">
                <b-img src="/img/icons/bottom-graph.svg" fluid center alt="Line drawing of community activity"/>
              </div>
              <div class="d-block d-sm-none">
                <b-img src="/img/bottomgraph-mobile.png" fluid center alt="Line drawing of community activity"/>
              </div>
            </b-col>
          </b-row>
        </section>
      </b-container>
    </section>
    <!-- <b-modal id="modal-center" centered v-model="showPopup" hide-footer	hide-header	hide-header-close	size="xl">
      <b-img src="/img/nowopen-popup.png" fluid class="d-none d-sm-block" @click="showPopup = false"/>
      <b-img src="/img/nowopen-popup-mobile.png" fluid class="d-block d-sm-none" @click="showPopup = false"/>
    </b-modal> -->
  </div>
</template>

<script>
import { TimelineLite, TweenMax } from "gsap";
import BubbleSvg from "@/components/BubbleSvg";
import BubbleMobile from "@/components/BubbleMobile";
export default {
  head: {
    script: [
      // {
      //   src:
      //     "https://cdn.cookielaw.org/consent/7f74f753-d421-4cf8-86d8-741322675d8b/OtAutoBlock.js"
      // },
      // {
      //   src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
      //   charset: "UTF-8",
      //   "data-domain-script": "7f74f753-d421-4cf8-86d8-741322675d8b",
      //   type: "text/javascript"
      // }
    ]
  },
  data() {
    return {
      // showPopup: false
      localStorage:{
        "hubspotutk":0,
        "sourceQuery":""
      }
    };
  },
  components: {
    BubbleSvg,
    BubbleMobile
  },
  beforeMount() {
    document.body.classList.add("home-page");
  },
  mounted() {
    // this.showPopup = true;
    this.$nextTick(() => {
      // this.fullscreen();
      this.$root.layout.methods.triggerViewPortAnimation();
      var hash = location.hash.replace("#", "");
      if (hash == "floorplans") {
        $("html, body").animate(
          {
            scrollTop: $("#builder-selection").offset().top
          },
          350
        );
      }
      this.localStorage.sourceQuery = this.getURLQuery(window.location.href);
      console.log(this.localStorage.sourceQuery);
      this.dynmDataStorage("sourceQuery", this.localStorage.sourceQuery);
      this.checkCookie();
      //console.log("cookie: "+document.cookie);
      // this.$store.subscribe((mutation, state) => {
      //   if(mutation.type == 'endAnimationScreen' && mutation.payload == false){
      //     this.$root.layout.methods.triggerViewPortAnimation()
      //   }
      // })
    });
    // window.addEventListener('resize', this.fullscreen);
  },
  destroyed() {
    document.body.classList.remove("home-page");
  },
  methods: {
    fullscreen() {
      var vm = this;
      if (document.documentElement.clientWidth >= 768) {
        const docHeight = document.documentElement.clientHeight,
          topHeight = $("header").outerHeight(true),
          bottomHeight = this.$children[0].$refs.BubbleAnchor.getBoundingClientRect()
            .height,
          textwrapper = $(".textwrapper").height();

        function offsetBottom(el, i) {
          i = i || 0;
          return $(el)[i].getBoundingClientRect().bottom;
        }

        var padding = 0;
        var t = $(".textwrapper p ").outerHeight(true);
        if (document.documentElement.clientWidth <= 1600) {
          padding = 20;
        } else if (document.documentElement.clientWidth <= 1920) {
          padding = 30;
        } else if (document.documentElement.clientWidth > 2000) {
          padding = 0;
        }
        var landingHeight = $(".landingpage-container .landingpage").css({
          height: docHeight - topHeight - bottomHeight + padding
        });

        setTimeout(() => {
          var pt = $(".toplogo")[0].getBoundingClientRect().height - topHeight;
          $(".landingpage .row").css({ paddingTop: pt });
        }, 250);
      }
    },
    dynmDataStorage(key,value){
      localStorage.setItem(key, value);
    },
    getCookie(){
        let hubCk = document.cookie;
        let temphubCk= hubCk.split("; ");
        for (let i = 0; i < temphubCk.length; i++) {
          let element = temphubCk[i];
          if(element.indexOf("hubspotutk") != -1){
            let temphubCkID = temphubCk[i].split("=");
            this.localStorage.hubspotutk = temphubCkID[1];
            // console.log(this.hubspotutk);
            // console.log(hubCk);
            break;
          }
        }
    },
    checkCookie() {
      let tempInterval = setInterval(()=>{
        this.getCookie();
        if(this.localStorage.hubspotutk != "0"){
          clearInterval(tempInterval);
          // console.log(this.localStorage.hubspotutk);
          this.dynmDataStorage("hubspotutk", this.localStorage.hubspotutk);
        }
      },1000);
    },
    getURLQuery(url){
      if (url.indexOf("?") != -1) {
        let str = url.substr(url.indexOf("?"));
        // console.log(str);
        return str;
      }else{
        return "";
      }
    }
  },
  transition: {
    mode: "out-in",
    css: false,
    appear: true,
    enter(el, done) {
      done();
      if (this.$store.state.animationScreen == false) {
        this.$root.layout.methods.triggerViewPortAnimation();
      }
    },
    leave(el, done) {
      done();
    }
  }
};
</script>

<style>
#builder-selection {
  background: white;
}
.home-selector {
  margin-top: 3%;
  text-align: center;
}
.home-selector-title {
  font-weight: 800;
}
.home-selector-img {
  width: 100%;
  height: 250px;
}
.logo-container {
  background-color: #d42b3b;
  padding: 1.5rem 0;
}
.logo-container img {
  height: 35px;
  width: auto;
}

@media (max-width: 1024px) {
  .logo-container img {
    height: 25px;
    width: auto;
  }
}

@media (max-width: 768px) {
  .logo-container img {
    height: 25px;
    width: auto;
  }
}
.modal-content {
  background-color: transparent;
  border: none;
}
#modal-center {
  background-color: transparent;
}
.modal-body {
  padding: 0;
}
.modal-backdrop {
  background-color: #fff !important;
  opacity: 0.8 !important;
}
.event-none {
  pointer-events: none;
}
</style>
